import React from "react";

import CadastroSimples from "../CadastroSimples";

// Cadastro global de modais de transporte (Cadastros Gerais), no padrão do Hub
// desde a sprint 638. Limites: código até 3, nome até 40, descrição até 255.
const CONFIG = {
  url: "/cadastros/modais",
  pageClass: "modais-page",
  heroTitle: "Modais",
  titulo: "Modal",
  singular: "modal",
  plural: "modais",
  novo: "Novo modal",
  icon: "tim-icons icon-delivery-fast",
  exportFilename: "modais",
  description:
    "Modais de transporte usados como referência nas tabelas de frete e nas integrações. O cadastro vale para todos os embarcadores.",
  codigo: { required: false, max: 3, placeholder: "Ex.: 01" },
  nome: { max: 40, placeholder: "Ex.: Rodoviário" },
  descricao: { max: 255 },
};

// somenteLeitura: nos produtos do cliente (consulta); a edição fica no Everlog
// Admin › Cadastros globais (sprint 638).
const Modais = ({ somenteLeitura }) => <CadastroSimples config={CONFIG} somenteLeitura={somenteLeitura} />;

export default Modais;
